import TextInput from "../components/basicComponents/text-input";
import TextArea from "../components/basicComponents/text-area";
import * as Icons from "../assets/SVGs/index";
import Button from "../components/basicComponents/button";
import { updateFormItem, addFormItem, removeFormItem } from "./form-helpers";

const renderFormSection = ({
  dataKey,
  formData,
  setFormData,
  fields,
  addItemLabel,
}: {
  dataKey: string;
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  fields: Array<{
    name: string;
    placeholder: string;
    component?: "TextInput" | "TextArea";
    RightIcon?: React.ReactNode;
  }>;
  addItemLabel: string;
}) => {
  return (
    <div className="mb-6 w-full">
      {formData[dataKey].map((item: any, index: number) => (
        <div
          key={index}
          className="flex items-center mb-2 md:flex-row flex-col gap-2"
        >
          <div className="flex flex-col gap-y-6 w-full">
            {fields.map((field) => {
              const FieldComponent =
                field.component === "TextArea" ? TextArea : TextInput;
              return (
                <FieldComponent
                  key={field.name}
                  name={field.name}
                  value={item[field.name]}
                  placeholder={field.placeholder}
                  RightIcon={field.RightIcon}
                  onChange={(
                    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                  ) =>
                    updateFormItem(
                      setFormData,
                      dataKey,
                      index,
                      field.name,
                      e.target.value
                    )
                  }
                />
              );
            })}
          </div>
          <Button
            onClick={() => removeFormItem(setFormData, dataKey, index)}
            title=""
            icon={<Icons.DeleteIcon className="w-5 h-5" />}
          />
        </div>
      ))}
      <Button
        title={addItemLabel}
        onClick={() =>
          addFormItem(
            setFormData,
            dataKey,
            fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
          )
        }
        variant="success"
      />
    </div>
  );
};

export default renderFormSection;
